import React, { useCallback, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { connect } from "react-redux";

import { Redirect } from "react-router";
import styles from "../RareRedirect/RareRedirect.module.sass";
import stylesUnauth from "../Unauthorized/Unauthorized.module.sass";

import { login, validateAccountUpgrade } from "../../store/actions";
import { LoadingIndicator } from "colbi_web_ui/lib/components";
import { ActionButton } from "colbi_web_ui/lib/components/inputs";
import warning from "../../assets/unauthorized.png";

import I18n from "../../I18n";

import { REACT_APP_SSO_BASE_URL } from "../../environmentVariables";
import { decodeUserSession } from "../../utils/utils";

const SSOCallback = (props) => {
    const [loginAttempt, setAttempt] = useState(false);
    const auth = useAuth();

    const [accountConfirmed, setAccountConfirmed] = useState(false);
    const { user, login, match, validateAccountUpgrade } = props;

    const { removeUser } = auth;
    const locale = match.params.locale || "en";
    const i18n = I18n.use(locale);
    const userInformation = decodeUserSession(user);

    const handleClick = () => {
        window.history.replaceState({}, document.title, "../../");

        const ssoUrl = REACT_APP_SSO_BASE_URL.endsWith("/")
            ? REACT_APP_SSO_BASE_URL.slice(0, -1)
            : REACT_APP_SSO_BASE_URL;
        return (window.location.href = `${ssoUrl}/my-profile`);
    };

    const loginOnAuth = useCallback(() => {
        if (!loginAttempt && !auth.isLoading && auth.isAuthenticated && !userInformation) {
            login(
                auth.user.profile.email,
                "",
                auth.user.profile["sovos:guid"],
                {
                    setAttempt: setAttempt,
                },
                auth,
            );
        }
    }, [userInformation, login, auth, loginAttempt]);

    useEffect(() => {
        loginOnAuth();
        return () => {};
    }, [loginOnAuth]);

    if (auth.isLoading) {
        return (
            <div className={styles["backdrop"]}>
                <LoadingIndicator className={`${styles["loading-indicator"]}`} />
            </div>
        );
    }

    if (!auth.isLoading && auth.isAuthenticated && userInformation) {
        if (userInformation && accountConfirmed) {
            return <Redirect to={`/${locale}/`} push />;
        }
        if (!userInformation.hasUpgradedAccount) {
            validateAccountUpgrade().then(() => setAccountConfirmed(true));
        } else {
            return <Redirect to={`/${locale}/`} push />;
        }
    }

    if (!auth.isLoading && !auth.isAuthenticated && !userInformation) {
        removeUser();
        return <Redirect to={`/login`} push />;
    }

    if (loginAttempt && !auth.isLoading && auth.isAuthenticated && !userInformation) {
        window.history.replaceState({}, document.title, "../unauthorized");

        return (
            <div className={stylesUnauth["unauthorized-container"]}>
                <img src={warning} alt="Warning" />
                <div>
                    <h2>{i18n`unauthorized`}</h2>
                    <h1 className={stylesUnauth["unauthorized-401"]}>401</h1>
                    <p>{i18n`unauthorized_description`} </p>
                    <ActionButton
                        primary
                        className={stylesUnauth["go-home"]}
                        onClick={() => handleClick()}
                    >
                        {i18n`Home`}
                    </ActionButton>
                </div>
            </div>
        );
    }

    if (!loginAttempt && !auth.isLoading && !auth.isAuthenticated && userInformation) {
        auth.signinRedirect({ login_hint: userInformation?.email });
    }

    return (
        <div className={styles["backdrop"]}>
            <LoadingIndicator className={`${styles["loading-indicator"]}`} />
        </div>
    );
};

export default connect(({ user }) => ({ user }), { login, validateAccountUpgrade })(SSOCallback);
